import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import MediumModal from '../../../../atoms/Modal/MediumModal';
import { useState } from 'react';
import { QuestionCreationFinalCall, QuestionCreationScreen, QuestionCreationScreenCancel } from '../../../../../redux/action';
import MCQ_singleAnswer from './QuestionType.js/MCQ-singleAnswer';
import MCQ_multiAnswer from './QuestionType.js/MCQ-multiAnswer';
import TITA from './QuestionType.js/TITA';
import TITA_specificRange from './QuestionType.js/TITA-specificRange';
import TITA_specificFormat from './QuestionType.js/TITA-specificFormat';
import TITA_specificFormatMulti from './QuestionType.js/TITA-specificFormatMulti';
import MCQ_multiAnswerMulti from './QuestionType.js/MCQ-multiAnswerMulti';
import axios from 'axios';
import { CallWithAuth } from '../../../../../action/apiActions';
import { GET_QUESTIOB_TYPE } from '../../../../../action/apiPath';
import { useNavigate } from 'react-router-dom';

import style from '../../../../../assets/styles/createQuestion.module.css'
import QuillEditor from '../../../../atoms/QuillEditor';
import DescriptveText from './QuestionType.js/Descriptive';

const CreatingQuestionGrouped = ({ id, getData }) => {
    // _______ initialization:start _______
    const dispatch = useDispatch()
    const navigate = useNavigate();
    // _______ initialization: end _______


    //_______ redux selector _______
    const selector = useSelector((state) => state.QuestionScreenReducer)
    const basicInfo = useSelector((state) => state.BasicInformationReducer)



    // console.log("basicInfo", basicInfo)
    // MODAL OPEN AND CLOSE 
    const [modalMedium, setModalMedium] = useState(false)
    const [modalData, setModalModalData] = useState({
        "title": "Requires a Review",
        "description": "The question needs to be reviewed by our team before adding it to the Question Bank",
        "cancelButton": "Continue Editing",
        "saveButton": "Send for Review"
    })

    const openModalMedium = () => {
        setModalMedium(true)
    }

    const closeModalMedium = () => {
        setModalMedium(false)
    }

    // total number of answer 
    // const [answers, setAnswers] = useState(["", "", "", ""])
    // const [correntAnswer, setCorrentAnswer] = useState("")

    // correct answer for TITA 
    // const [correntAnswerTita, setCorrentAnswerTita] = useState([])

    // function to add the multiple options 
    // function AddAnswerCall() {
    //     setAnswers(current => [...current, ""])
    // }

    // function to close the multiple options
    // function CloseAnswerCall() {
    //     const newArray = [...answers]
    //     newArray.pop()
    //     setAnswers(newArray)
    // }

    // state of explanation_text and compose text 
    // const [questionDirection, setQuestionDirection] = useState(null)
    // const [explanation_text, setExplanation_text] = useState(null)
    // const [compose_text, setCompose_text] = useState(null)
    // const [explanation_video, setExplanation_video] = useState(null)
    // const [lastIndex, setlastIndex] = useState(null)
    // const [randomise_answers, setRandomise_answers] = useState(false)
    const [passage_text, setPassage_text] = useState(null)

    console.log("passage_text", passage_text)

    // encode tunymce to normal text 
    const decode = (item, key, index) => {

        if (item.length > 0) {
            // Your HTML content in a variable
            const htmlString = item;

            // Create a new DOMParser
            const parser = new DOMParser();

            // Parse the HTML string
            const parsedHtml = parser.parseFromString(htmlString, 'text/html');

            // Access the innerHTML property of the first child
            const innerHTML = parsedHtml.body.firstChild.innerHTML;

            // Store innerHTML in a variable
            const myVariable = innerHTML;

            // Now you have the innerHTML content (i.e., "helljhabdsaho") saved in the `myVariable` variable
            key(myVariable);
        } else {

        }


    }

    // const [questionNumber, setQuestionNumber] = useState([])

    // body of finalcall API 
    // const body = {
    //     "question_type_id": selector.questiontype.question_type_id.id,
    //     "question_direction": questionDirection,
    //     "compose_question": compose_text,
    //     "options": answers,
    //     "correct_answer": selector.questiontype.question_type_id.id === 4 || selector.questiontype.question_type_id.id === 5 ? correntAnswerTita.toString() : correntAnswer.toString(),
    //     "last_option_idx": lastIndex,
    //     "randomise_answers": randomise_answers,
    //     "explaination_video": explanation_video,
    //     "explaination_text": explanation_text
    // }

    // console.log("selector",selector)

    const [bodyformultiquestion, setbodyformultiquestion] = useState([
        {
            "idx": 0,
            "question_type_id": basicInfo.question_group[0].question_type_id,
            "question_short_identifier": Array.isArray(getData) ? getData[0]?.question_short_identifier || null : null,
            "compose_question": Array.isArray(getData) ? getData[0]?.compose_question || null : null,
            "options": Array.isArray(getData) ? getData[0]?.options || null : null,
            "correct_answer": Array.isArray(getData) ? getData[0]?.correct_answer || null : null,
            "last_option_idx": Array.isArray(getData) ? getData[0]?.last_option_idx || null : null,
            "randomise_answers": Array.isArray(getData) ? getData[0]?.randomise_answers || false : false,
            "explaination_video": Array.isArray(getData) ? getData[0]?.explaination_video || null : null,
            "explaination_text": Array.isArray(getData) ? getData[0]?.explaination_text || null : null,
            "answer_format": Array.isArray(getData) ? getData[0]?.answer_format || null : null,
            "task_label": null,
            "video_id": Array.isArray(getData) ? getData[0]?.video_id || null : null,
        },
        {
            "idx": 1,
            "question_type_id": basicInfo.question_group[1].question_type_id,
            "question_short_identifier": Array.isArray(getData) ? getData[1]?.question_short_identifier || null : null,
            "compose_question": Array.isArray(getData) ? getData[1]?.compose_question || null : null,
            "options": Array.isArray(getData) ? getData[1]?.options || null : null,
            "correct_answer": Array.isArray(getData) ? getData[1]?.correct_answer || null : null,
            "last_option_idx": Array.isArray(getData) ? getData[1]?.last_option_idx || null : null,
            "randomise_answers": Array.isArray(getData) ? getData[1]?.randomise_answers || false : false,
            "explaination_video": Array.isArray(getData) ? getData[1]?.explaination_video || null : null,
            "explaination_text": Array.isArray(getData) ? getData[1]?.explaination_text || null : null,
            "answer_format": Array.isArray(getData) ? getData[1]?.answer_format || null : null,
            "task_label": null,
            "video_id": Array.isArray(getData) ? getData[1]?.video_id || null : null,
        }
    ])
    const [finalbody, setfinalbody] = useState(null)
    const [question, setQuestion] = useState([0, 1])
    const [questionbutton, setQuestionButton] = useState(0)



    // console.log("basicInfo",basicInfo)

    useEffect(() => {
        const generateBodyForMultiQuestion = () => {
            return basicInfo.question_group.map((question, index) => ({
                idx: index,
                question_type_id: question.question_type_id,
                question_short_identifier: Array.isArray(getData) ? getData[index]?.question_short_identifier || null : null,
                compose_question: Array.isArray(getData) ? getData[index]?.compose_question || null : null,
                options: Array.isArray(getData) ? getData[index]?.options || null : null,
                correct_answer: Array.isArray(getData) ? getData[index]?.correct_answer || null : null,
                last_option_idx: Array.isArray(getData) ? getData[index]?.last_option_idx || null : null,
                randomise_answers: Array.isArray(getData) ? getData[index]?.randomise_answers || false : false,
                explaination_video: Array.isArray(getData) ? getData[index]?.explaination_video || null : null,
                explaination_text: Array.isArray(getData) ? getData[index]?.explaination_text || null : null,
                answer_format: Array.isArray(getData) ? getData[index]?.answer_format || null : null,
                task_label: null,
                video_id: Array.isArray(getData) ? getData[index]?.video_id || null : null,
            }));
        };

        const generateQuestionArray = () => {
            return Array.from({ length: basicInfo.question_group.length }, (_, index) => index);
        };

        // Update the state
        setPassage_text(Array.isArray(getData) ? getData[0]?.passage : "")
        setQuestion(generateQuestionArray());
        setbodyformultiquestion(generateBodyForMultiQuestion());


    }, [basicInfo])

    // function to add the multiple QUESTIONS AND ANSWERS 
    // const AddBodyQuestion = () => {
    //     const updatebody = [...bodyformultiquestion];
    //     updatebody[questionbutton] = {
    //         "question_type_id": questionTypeScreen,
    //         "question_direction": questionDirection,
    //         "compose_question": compose_text,
    //         "options": answers,
    //         "correct_answer": selector.questiontype.question_type_id.id === 4 || selector.questiontype.question_type_id.id === 5 ? correntAnswerTita.toString() : correntAnswer.toString(),
    //         "last_option_idx": lastIndex,
    //         "randomise_answers": randomise_answers,
    //         "explaination_video": explanation_video,
    //         "explaination_text": explanation_text
    //     };
    //     setbodyformultiquestion(updatebody);
    // }

    // function to make final body 
    // const FinalBodyCreate = () => {
    //     const finalBody = {
    //         "question_group": bodyformultiquestion,
    //         "passage": passage_text
    //     }
    //     setfinalbody(finalBody)
    // }

    // to get the final data for multiple questions of the TITA and others 
    // useEffect(() => {
    //     FinalBodyCreate()
    // }, [bodyformultiquestion])


    // effect to add answer call for multiple question data 
    // useEffect(() => {
    //     AddBodyQuestion()
    // }, [questionDirection, compose_text, answers, correntAnswerTita, correntAnswer, lastIndex, randomise_answers, explanation_video, explanation_text])

    // _______ TO close MULTIPLE QUESTION AND ANSWER for same screen _______
    const closeQuestion = () => {
        setQuestion(question.filter((items, i) => items !== questionbutton))
        setQuestionButton(questionbutton - 1)
    }


    // ________ get category from API and grouped in sequence ________
    const [questionCategory, setQuestionCategory] = useState([])
    const [slectedquestionCategory, setSelectedQuestionCategory] = useState(0)

    const GetQuestionTypeCategory = async () => {
        const category = await CallWithAuth("GET", GET_QUESTIOB_TYPE)
        if (category.status && category.res.status === 200) {
            setQuestionCategory(category.res.data)
        }
    }

    useEffect(() => {
        GetQuestionTypeCategory()
    }, [])


    {/*________question type getting from screen 2.1 and dropdown for changing for question________*/ }
    const [questionTypeScreen, setQuestionTypeScreen] = useState(0)

    const SetSelectQuestionType = (e) => {
        const updatebody = [...bodyformultiquestion];
        updatebody[questionbutton] = {
            "idx": questionbutton,
            "question_type_id": e,
            "question_short_identifier": null,
            "compose_question": null,
            "options": null,
            "correct_answer": null,
            "last_option_idx": null,
            "randomise_answers": false,
            "explaination_video": null,
            "explaination_text": null,
            "answer_format": null,
            // "difficulty": basicInfo.difficulty,
            // "question_type": e,
            // "format": basicInfo.format,
            "task_label": null,
            "video_id": null,
        };
        setbodyformultiquestion(updatebody);
    }


    useEffect(() => {
        setfinalbody({
            "question_group": bodyformultiquestion,
            "passage": passage_text
        })
    }, [bodyformultiquestion, passage_text])


    useEffect(() => {
        setQuestionTypeScreen(selector.questiontype?.question_type_id?.id)
    }, [selector])



    // console.log("bodyformultiquestion",bodyformultiquestion)





    // drag practice

    const draggables = document.querySelectorAll('.draggable')
    const containers = document.querySelectorAll('.container')

    draggables.forEach(draggable => {
        draggable.addEventListener('dragstart', () => {
            draggable.classList.add('dragging')
        })

        draggable.addEventListener('dragend', () => {
            draggable.classList.remove('dragging')
        })
    })

    containers.forEach(container => {
        container.addEventListener('dragover', e => {
            e.preventDefault()
            const afterElement = getDragAfterElement(container, e.clientY)
            const draggable = document.querySelector('.dragging')
            if (afterElement == null) {
                container.appendChild(draggable)
            } else {
                container.insertBefore(draggable, afterElement)
            }
        })
    })

    function getDragAfterElement(container, y) {
        const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

        return draggableElements.reduce((closest, child) => {
            const box = child.getBoundingClientRect()
            const offset = y - box.top - box.height / 2
            if (offset < 0 && offset > closest.offset) {
                return { offset: offset, element: child }
            } else {
                return closest
            }
        }, { offset: Number.NEGATIVE_INFINITY }).element
    }

    // _____________ MODAL OPEN AND CLOSE _____________
    const [modalMediumCancel, setModalMediumCancel] = useState(false)
    const [modalDataCancel, setModalModalDataCancel] = useState({
        "title": "Are You Sure, Do You Want To Cancel Question Creation?",
        "description": "Your Current Changes Will Not Be Saved And You Will Be Redirected To Question Listing ",
        "cancelButton": "Continue Editing",
        "saveButton": "Yes, Cancel"
    })

    const openModalMediumCancel = () => {
        setModalMediumCancel(true)
    }

    const closeModalMediumCancel = () => {
        setModalMediumCancel(false)
    }

    // cancel button to send the user to question-bank 
    const Cancel = () => {
        navigate('/question-bank')
        dispatch(QuestionCreationScreenCancel())
    }


    function b64DecodeUnicode(str) {
        return decodeURIComponent(
            atob(str)
                .split("")
                .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );
    }


    // console.log("getData==>>",getData)
    return (
        <>


            {/* add passage/text with tnymce*/}
            <div className={style.passage_text}>
                <p>Add Passage/Text <b className={style.red_mendantory}>*</b></p>
                {/* <Editor
                    value={passage_text != null && b64DecodeUnicode(passage_text)}
                    apiKey='43r1aznok44zxafnhlerjdhremu6cizk6ropi635y4we48qz'
                    onEditorChange={(newText, editor) => {
                        setPassage_text(btoa(editor.getContent({ format: 'html' })))
                    }}
                /> */}
                <div style={{ height: "auto", flexGrow: "1" }}>
                    <QuillEditor
                        defaultValue={passage_text != null && b64DecodeUnicode(passage_text)}
                        onChange={(content) => setPassage_text(btoa(content))} />
                </div>
            </div>

            {/* MULTIPLE QUESTION AND WHICH IS RUNNING CURRENTLY in BLUE  */}


            {/* <div className='multiquestion'>
                {question?.map((items, i) => (
                    <button className={items === questionbutton ? 'multiquestionbutton' : 'multiquestionbuttonBlue'} onClick={() => setQuestionButton(i)}>

                        {items === questionbutton ?
                            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z" fill="white" />
                            </svg>
                            : <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z" fill="#272727" />
                            </svg>} &nbsp;

                        Question {i + 1}
                    </button>
                ))}
            </div> */}

            <div className={style.container}>
                {question?.map((items, i) => (
                    <button draggable="true" className={items === questionbutton ? ` ${style.multiquestionbutton} ${style.draggable}` : ` ${style.multiquestionbuttonBlue} ${style.draggable}`} onClick={() => setQuestionButton(i)}>

                        {items === questionbutton ?
                            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z" fill="white" />
                            </svg>
                            : <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z" fill="#272727" />
                            </svg>} &nbsp;

                        Question {i + 1}
                    </button>
                ))}

                {/* <p class="draggable" draggable="true">1</p>
                <p class="draggable" draggable="true">2</p> */}
            </div>


            {/* Add question button: to add more answer  */}
            {/* <div className={` ${style.Add_answer} ${style.pointer}`} onClick={() => setQuestion(current => [...current, question.length])} >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#00ABFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.5 12H16.5" stroke="#00ABFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 16.5V7.5" stroke="#00ABFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Add Question</span>
            </div> */}

            {/* Current QUESTION RUNNING  */}
            <div className={style.questions_remove}>
                <div className={style.titles}>
                    <span>Question {questionbutton + 1}</span>
                </div>
                {/* {question.length > 2 ? <div className={style.remove}>
                    <button className={` ${style.remove_question} ${style.pointer}`} onClick={() => closeQuestion()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062" stroke="#272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047" stroke="#272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        <span>Remove</span>
                    </button>
                </div> : ""} */}
            </div>


            {/* question type getting from screen 2.1 and dropdown for changing for question*/}
            <select name="question" id="question" className={` ${style.question_creating} ${style.pointer}`} onClick={(e) => SetSelectQuestionType(JSON.parse(e.target.value).id)}>
                {/* <option value={JSON.stringify(questionCategory.filter((items,i)=>items.id===bodyformultiquestion[questionbutton].question_type_id).map((item,i)=>(item)))} hidden > - {questionCategory.filter((items,i)=>items.id===bodyformultiquestion[questionbutton].question_type_id).map((item,i)=>(item.name))}</option> */}
                {questionCategory.map((items, i) => (
                    <>
                        <option value={JSON.stringify(items)} selected={bodyformultiquestion[questionbutton]?.question_type_id === items.id} >{items.category} - {items.name}</option>
                    </>
                ))}
            </select>


            {/*_______  QUESTION TYPE SCREEN ACCORDING TO SELECTOR _______  */}
            {bodyformultiquestion[questionbutton]?.question_type_id === 1 ? <MCQ_singleAnswer key={questionbutton} body={bodyformultiquestion} questionbutton={questionbutton} setbodyformultiquestion={setbodyformultiquestion} /> : ""}
            {bodyformultiquestion[questionbutton]?.question_type_id === 2 ? <MCQ_multiAnswer key={questionbutton} body={bodyformultiquestion} questionbutton={questionbutton} setbodyformultiquestion={setbodyformultiquestion} /> : ""}
            {bodyformultiquestion[questionbutton]?.question_type_id === 3 ? <TITA key={questionbutton} body={bodyformultiquestion} questionbutton={questionbutton} setbodyformultiquestion={setbodyformultiquestion} /> : ""}
            {bodyformultiquestion[questionbutton]?.question_type_id === 4 ? <TITA_specificRange key={questionbutton} body={bodyformultiquestion} questionbutton={questionbutton} setbodyformultiquestion={setbodyformultiquestion} /> : ""}
            {bodyformultiquestion[questionbutton]?.question_type_id === 5 ? <TITA_specificFormat key={questionbutton} body={bodyformultiquestion} questionbutton={questionbutton} setbodyformultiquestion={setbodyformultiquestion} /> : ""}
            {bodyformultiquestion[questionbutton]?.question_type_id === 6 ? <DescriptveText body={bodyformultiquestion} questionbutton={questionbutton} setbodyformultiquestion={setbodyformultiquestion} /> : ""}
            {/* {selector.questiontype.question_type_id.id === 6 ? <TITA_specificFormatMulti questionbutton={questionbutton} setPassage_text={setPassage_text} setQuestionButton={setQuestionButton} setQuestion={setQuestion} question={question} correntAnswerTita={correntAnswerTita} setCorrentAnswerTita={setCorrentAnswerTita} correntAnswer={correntAnswer} explanation_text={explanation_text} setQuestionDirection={setQuestionDirection} setRandomise_answers={setRandomise_answers} answers={answers} AddAnswerCall={AddAnswerCall} setExplanation_video={setExplanation_video} setAnswers={setAnswers} setCorrentAnswer={setCorrentAnswer} CloseAnswerCall={CloseAnswerCall} setlastIndex={setlastIndex} setCompose_text={setCompose_text} setExplanation_text={setExplanation_text} decode={decode} /> : ""}
            {selector.questiontype.question_type_id.id === 7 ? <MCQ_multiAnswerMulti questionbutton={questionbutton} setQuestionButton={setQuestionButton} setQuestion={setQuestion} question={question} correntAnswerTita={correntAnswerTita} setCorrentAnswerTita={setCorrentAnswerTita} correntAnswer={correntAnswer} explanation_text={explanation_text} setQuestionDirection={setQuestionDirection} setRandomise_answers={setRandomise_answers} answers={answers} AddAnswerCall={AddAnswerCall} setExplanation_video={setExplanation_video} setAnswers={setAnswers} setCorrentAnswer={setCorrentAnswer} CloseAnswerCall={CloseAnswerCall} setlastIndex={setlastIndex} setCompose_text={setCompose_text} setExplanation_text={setExplanation_text} decode={decode} /> : ""} */}



            {/* SAVE AND CONTINUE  */}
            <div className={style.saveButton_questionCreation}>
                <div className={` ${style.cancel} ${style.pointer}`} onClick={() => openModalMediumCancel()}>
                    Cancel
                </div>
                <div>
                    <button className={style.blue_button} onClick={() => openModalMedium()}>Save & Continue</button>
                </div>
            </div>
            {/* SAVE AND CONTINUE  */}


            {/* MEDIUM MODAL CALL with dispatch function  */}
            <MediumModal modalData={modalData} forwardButton={() => dispatch(QuestionCreationFinalCall(finalbody, id))} modalMedium={modalMedium} openModalMedium={openModalMedium} closeModalMedium={closeModalMedium} />
            {/* dispatch(QuestionCreationFinalCall(finalbody, id)) */}

            <MediumModal modalMedium={modalMediumCancel} forwardButton={() => Cancel()} openModalMedium={openModalMediumCancel} closeModalMedium={closeModalMediumCancel} modalData={modalDataCancel} />
        </>
    )
}

export default CreatingQuestionGrouped